import { createBrowserRouter } from 'react-router';

import { PaginaPerfis } from '@/features/admin/pagina-perfis';
import { PaginaUsuarios } from '@/features/admin/pagina-usuarios';
import { PaginaLogin } from '@/features/auth/pagina-login';
import { PaginaSenha } from '@/features/auth/pagina-senha';
import { RequerSessao, ROTA_SENHA } from '@/features/auth/requer-sessao';
import { PaginaCaptura } from '@/features/captura/pagina-captura';
import { PaginaChaves } from '@/features/chaves/pagina-chaves';
import { PaginaDocumentos } from '@/features/documentos/pagina-documentos';
import { PaginaEmpresa } from '@/features/empresas/pagina-empresa';
import { PaginaEmpresas } from '@/features/empresas/pagina-empresas';
import { PaginaHistorico } from '@/features/importacao/pagina-historico';
import { PaginaImportacao } from '@/features/importacao/pagina-importacao';
import { PaginaLote } from '@/features/importacao/pagina-lote';
import { PaginaInicio } from '@/features/inicio/pagina-inicio';
import { PaginaPendencias } from '@/features/pendencias/pagina-pendencias';
import { PaginaRelatorios } from '@/features/relatorios/pagina-relatorios';

import { LayoutAutenticado } from './layout-autenticado';
import { PaginaNaoEncontrada } from './pagina-nao-encontrada';
import { NOME_PRODUTO } from './produto';
import { RequerPermissao } from './requer-permissao';
import { SemConteudo } from './sem-conteudo';

const rotasDev = import.meta.env.DEV
  ? [
      {
        path: '/dev/ds',
        HydrateFallback: SemConteudo,
        lazy: async () => ({ Component: (await import('./catalogo/catalogo')).Catalogo }),
      },
    ]
  : [];

export const rotas = [
  { path: '/entrar', element: <PaginaLogin nomeProduto={NOME_PRODUTO} /> },
  {
    path: ROTA_SENHA,
    element: (
      <RequerSessao nomeProduto={NOME_PRODUTO} telaDeSenha>
        <PaginaSenha nomeProduto={NOME_PRODUTO} />
      </RequerSessao>
    ),
  },
  ...rotasDev,
  {
    element: (
      <RequerSessao nomeProduto={NOME_PRODUTO}>
        <LayoutAutenticado />
      </RequerSessao>
    ),
    children: [
      { index: true, element: <PaginaInicio /> },
      { path: 'documentos', element: <PaginaDocumentos /> },
      { path: 'importacao', element: <PaginaImportacao /> },
      { path: 'importacao/historico', element: <PaginaHistorico /> },
      { path: 'importacao/:id', element: <PaginaLote /> },
      { path: 'captura', element: <PaginaCaptura /> },
      { path: 'chaves', element: <PaginaChaves /> },
      { path: 'pendencias', element: <PaginaPendencias /> },
      { path: 'relatorios', element: <PaginaRelatorios /> },
      { path: 'empresas', element: <PaginaEmpresas /> },
      { path: 'empresas/:id', element: <PaginaEmpresa /> },
      {
        path: 'admin/pessoas',
        element: (
          <RequerPermissao permissao="plataforma.usuarios.ler">
            <PaginaUsuarios />
          </RequerPermissao>
        ),
      },
      {
        path: 'admin/perfis',
        element: (
          <RequerPermissao permissao="plataforma.perfis.gerenciar">
            <PaginaPerfis />
          </RequerPermissao>
        ),
      },
      { path: '*', element: <PaginaNaoEncontrada /> },
    ],
  },
];

export const roteador = createBrowserRouter(rotas);
